module.exports = __webpack_public_path__ + "media/stylesheets/images/steven様02 1-7a321fdd6d9479628eba13b4969ef4bb.jpg";